import {SelectItem} from "@/store/types";

export interface TemplatesState {
  templates?: any
  allTemplates: TemplateItem[]
  multichannelTemplates?: any[]
  templateItem?: TemplateItem
  distributions: DistributionItem[]
  templateObject: TemplateItem
}

export interface DistributionItem {
  batchId: number,
  createDatetime: string,
  recipient: number,
  transport: string,
  status: {
    id: number,
    name: string
  },
  comment: string,
  startDatetime: string,
  endDatetime: string
}

export interface DistributionFilter {
  name?: string | null,
  transport?: string | null,
  status?: string | null,
  comment?: string | null,
  page_number?: number,
}

export interface TemplatesFilterParams {
  id?: number,
  is_active?: number | string,
  partner?: string,
  partner_user?: string,
  name?: string,
  status?: string,
  priority?: string,
  message?: string,
  content?: string,
  subject?: string,
}

export interface TemplateItem {
  templateId?: number,
  name: string,
  message?: string,
  lifetime?: number | null,
  startDatetime?: string | null,
  endDatetime?: string | null,
  allowedDays?: string[],
  distribution?: boolean,
  startingDate?: string | null,
  endingDate?: string | null,
  timeBegin?: string | null,
  timeEnd?: string | null,
  senderId?: null | number,
  messageTypeId?: number | null,
  blackListId?: number | null,
  multichannelId?: number | null,
  multichannelTemplateId?: number | null,
  timeout?: number|null,
}

export interface SmsTemplateItem extends TemplateItem {
  messageLength?: number | null
}

export class TemplateItemImpl implements TemplateItem {
  constructor() {
    this.name = '',
    this.message = '';
    this.lifetime = null,
    this.startDatetime = null,
    this.endDatetime = null,
    this.allowedDays = ['MON','TUE','WED','THU','FRI','SAT','SUN'],
    this.distribution = false,
    this.startingDate = null,
    this.endingDate = null,
    this.timeBegin = null,
    this.timeEnd = null,
    this.senderId = null,
    this.messageTypeId = null,
    this.blackListId = null,
    this.multichannelId = null,
    this.multichannelTemplateId = null,
    this.timeout = null
  }
  templateId?: number;
  name: string;
  message?: string;
  lifetime?: number | null;
  startDatetime?: string | null;
  endDatetime?: string | null;
  allowedDays?: string[];
  distribution?: boolean;
  startingDate?: string | null;
  endingDate?: string | null;
  timeBegin?: string | null;
  timeEnd?: string | null;
  senderId?: null | number;
  messageTypeId?: number | null;
  blackListId?: number | null;
  multichannelId?: number | null;
  multichannelTemplateId?: number | null;
  timeout?: number|null;
}

export class SmsTemplateItemImpl extends TemplateItemImpl {
  messageLength?: number | null

  constructor() {
    super();
    this.messageLength = null;
  }
}

export class CallTemplateItemImpl extends TemplateItemImpl {
  payloadType?: string;
  maxRepeatCount?: number|null
  repeatDtmf?: number|null
  callRedirectDtmf?: number|null
  redirectNumber?: number|null
  sendSmsDtmf?: number|null
  smsTemplateId?: number|null
  dialing?: number|null
  maxRetryCount?: number|null
  retryInterval?: number|null

  constructor() {
    super();
    this.payloadType = '';
    this.maxRepeatCount = null
    this.repeatDtmf = null
    this.callRedirectDtmf = null
    this.redirectNumber = null
    this.sendSmsDtmf = null
    this.smsTemplateId = null
    this.dialing = 30
    this.maxRetryCount = null
    this.retryInterval = null
  }
}

export interface EmailFileItem {
  id?: number,
  name: string,
  fileData: string,
  fileSize?: string
}
export class EmailTemplateItemImpl extends TemplateItemImpl {
  subject?: string;
  from?: string;
  attachedFiles?: EmailFileItem[];

  constructor() {
    super();
    this.subject = '';
    this.from = '';
    this.attachedFiles = [];
  }
}

export class PushTemplateItemImpl extends TemplateItemImpl {
  title?: string;
  content?: string;
  applicationId?: number|null;

  constructor() {
    super();
    this.title = '';
    this.content = '';
    this.applicationId = null;
  }
}

export class ViberTemplateItemImpl extends TemplateItemImpl {
  image?: string;
  buttonName?: string;
  buttonLink?: string;

  constructor() {
    super();
    this.image = '';
    this.buttonName = '';
    this.buttonLink = '';
  }
}

export class WhatsAppTemplateItemImpl extends TemplateItemImpl {

}

export class CustomTemplateItemImpl extends TemplateItemImpl {
  image?: string;
  buttonName?: string;
  buttonLink?: string;

  constructor() {
    super();
    this.image = '';
    this.buttonName = '';
    this.buttonLink = '';
  }
}

export class MailNotifyTemplateItemImpl extends TemplateItemImpl {
  mnServiceId: number|null;
  mnTemplateId: number|null;
  routes: string;
  vkMessage: string;
  okMessage: string;

  constructor() {
    super();
    this.mnServiceId = null;
    this.mnTemplateId = null;
    this.routes = 'vk';
    this.vkMessage = '';
    this.okMessage = '';
  }
}